<template>
  <q-dialog persistent ref="dialogRef">

    <q-card v-if="state === 'SAVE'" class="modal-container">
      <ModalHeader header="Upload Recording" @on-close="state = 'EXIT'" />
      <q-card-section class="column">
        <label class="text-weight-medium">Meeting Name</label>
        <BrandInput
          dense
          class="q-mt-xs"
          v-model.trim="recordingName"
          :rules="[(val) => val?.length > 0 || 'Enter name']"
        />

        <q-checkbox
          v-if="hasJobberIntegration"
          v-model="integration.type"
          label="Integrate with Jobber"
          :true-value="'jobber'"
          :false-value="null"
        />

        <label v-if="integration.type === 'jobber'" class="text-weight-medium">Select Job</label>
        <JobDropdown
          v-if="integration.type === 'jobber'"
          :integration="integration.type"
          :account-id="integration.accountId"
          @onSelect="onJobSelect"
        />

        <label class="text-weight-medium q-mt-lg">AI Coach</label>
        <AiTemplatesDropdown @onSelect="({ id }) => (aiTemplateId = id)" cache />
      </q-card-section>
      <q-separator class="q-mx-md" spaced />
      <q-card-actions vertical>
        <RecordingUploadBtn
          :disable="!recordingName"
          :localRecordingId="localRecordingId"
          :recordingName="recordingName || localRecordingName"
          :aiTemplateId="aiTemplateId"
          :integrationData="integration"
          @on-queued="onQueued"
          @record-uploading-failed="$emit('hide')"
        >
          Upload Recording
        </RecordingUploadBtn>
      </q-card-actions>
    </q-card>

    <q-card v-else-if="state === 'NO-NAME'" class="modal-container">
      <ModalHeader header="Upload Recording" @on-close="state = 'SAVE'" />
      <q-card-section>
        <div class="modal-section-header text-bold">Are you sure you want to want to save?</div>
        <div>
          <span class="text-negative text-bold">lost</span>.
        </div>
      </q-card-section>
      <q-separator class="q-mx-md" spaced />
      <q-card-actions vertical>
        <PrimaryButton @click="state = 'SAVE'">No</PrimaryButton>
        <q-btn rounded @click="onCancelSaving(localRecordingId)">Yes</q-btn>
      </q-card-actions>
    </q-card>
    
    <q-card v-else-if="state === 'EXIT'" class="modal-container" >
      <ModalHeader header="Cancel Upload" @on-close="state = 'SAVE'"/>
      <q-card-section>
        <div>
          You are about to cancel the upload. All unsaved changes will be <span class="text-negative text-bold">lost</span>. Are you sure?
        </div>
      </q-card-section>
      <q-separator class="q-mx-md" spaced />
      <q-card-actions vertical>
        <PrimaryButton @click="state = 'SAVE'">Go Back</PrimaryButton>
        <q-btn rounded @click="onCancelSaving(localRecordingId)" text-color="negative">Cancel Upload</q-btn>
      </q-card-actions>
    </q-card>
    
  </q-dialog>
</template>

<script>
import { useRoute } from 'vue-router';
import { useDialogPluginComponent } from 'quasar';
import { mapState } from 'vuex';

import RecordingUploadBtn from '@/components/blocks/RecordingUploadBtn.vue';
import AiTemplatesDropdown from '@/components/blocks/AiTemplatesDropdown.vue';
import JobDropdown from '@/components/blocks/JobDropdown.vue';
import ModalHeader from '@/components/modals/ModalHeader.vue';
import BrandInput from '@/components/brand/BrandInput.vue';
import PrimaryButton from '@/components/brand/PrimaryButton.vue';

export default {
  components: {
    RecordingUploadBtn,
    ModalHeader,
    BrandInput,
    PrimaryButton,
    AiTemplatesDropdown,
    JobDropdown,
  },
  props: {
    localRecordingId: {
      type: String,
      required: true,
    },
    localRecordingName: {
      type: String,
      required: false,
    },
  },
  emits: [...useDialogPluginComponent.emits],
  data() {
    const route = useRoute();
    return {
      state: 'SAVE', // EXIT SAVE NO-NAME
      isConfirmExit: false,
      URL,
      isLoading: false,
      recordingName: this.localRecordingName === 'Untitled' ? '' : this.localRecordingName,
      aiTemplateId: '',
      integration: {
        type: route.query.integration || null,
        accountId:
          route.query.accountId || this.userProfile?.linkedAccounts?.jobber?.accountId || null,
        jobId: route.query.jobId || null,
        visitId: route.query.visitId || null,
      },
    };
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.userProfile,
    }),
    hasJobberIntegration() {
      return this.userProfile?.linkedAccounts?.jobber?.accountId;
    },
    isIntegrationValid() {
      if (this.integration.type === 'jobber') {
        return !!this.integration.jobId;
      }
      return true;
    },
  },
  methods: {
    onQueued() {
      this.$store.commit('setRecordingWidget', false);
      this.$router.push({ name: 'Meetings', query: { uids: [this.userProfile.uid] } });
      this.$emit('hide');
    },
    async onCancelSaving(localRecordingId) {
      await this.$store.dispatch('recs/local/deleteLocalRecording', localRecordingId);
      this.$emit('hide');
    },
    onJobSelect({ jobId, visitId }) {
      this.integration.jobId = jobId;
      this.integration.visitId = visitId;
      this.integration.accountId = this.userProfile?.linkedAccounts?.jobber?.accountId;
    },
  },
};
</script>

<style scoped>
.modal-section-header {
  font-size: 0.9rem;
}
</style>
